function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8036 9.19643V3.61607C10.8036 3.32007 10.686 3.03619 10.4767 2.82689C10.2674 2.61759 9.9835 2.5 9.6875 2.5C9.3915 2.5 9.10762 2.61759 8.89832 2.82689C8.68901 3.03619 8.57143 3.32007 8.57143 3.61607V9.19643H2.99107C2.69507 9.19643 2.41119 9.31401 2.20189 9.52332C1.99259 9.73262 1.875 10.0165 1.875 10.3125C1.875 10.6085 1.99259 10.8924 2.20189 11.1017C2.41119 11.311 2.69507 11.4286 2.99107 11.4286H8.57143V17.0089C8.57143 17.3049 8.68901 17.5888 8.89832 17.7981C9.10762 18.0074 9.3915 18.125 9.6875 18.125C9.9835 18.125 10.2674 18.0074 10.4767 17.7981C10.686 17.5888 10.8036 17.3049 10.8036 17.0089V11.4286H16.3839C16.6799 11.4286 16.9638 11.311 17.1731 11.1017C17.3824 10.8924 17.5 10.6085 17.5 10.3125C17.5 10.0165 17.3824 9.73262 17.1731 9.52332C16.9638 9.31401 16.6799 9.19643 16.3839 9.19643H10.8036Z",
  fill: "#7B7C7C"
});

function SvgIcNewArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewArea);
export default ForwardRef;